/* eslint-disable no-restricted-globals */
import { Asset } from '@tassat/fred-definitions';
import numeral from 'numeral';

import { formatCurrencyWithDecimal } from './helpers';

export const assetAsNumber = (amount) => numeral(amount);

export const formatAsAsset = (
    amount,
    asset?: Pick<Asset, 'Ticker' | 'Symbol' | 'DecimalPoint' | 'Curcode'>,
    displayType?: 'ticker' | 'curcode' | 'symbol' | undefined,
    useColonMark: boolean = false,
    truncateZeros: boolean = false
) => {
    if (isNaN(amount)) {
        return amount;
    }

    if (asset !== undefined) {
        const assetWithDecimal = formatCurrencyWithDecimal(
            amount,
            asset?.DecimalPoint,
            truncateZeros
        );
        if (displayType === 'symbol' || displayType === undefined) {
            return `${asset?.Symbol}${useColonMark ? ':' : ''}${assetWithDecimal}`;
        }
        if (displayType === 'ticker' || displayType === undefined) {
            return `${asset?.Ticker}${useColonMark ? ':' : ''} ${assetWithDecimal}`;
        }
        if (displayType === 'curcode') {
            return `${asset?.Curcode}${useColonMark ? ':' : ''} ${assetWithDecimal}`;
        }
    }

    return numeral(amount)
        .format('$0,.00');
};

export const formatAsAssetNoSign = (amount, asset?: Asset, truncateZeros: boolean = false) => {
    if (isNaN(amount)) {
        return amount;
    }

    if (asset !== undefined) {
        const assetWithDecimal = formatCurrencyWithDecimal(
            amount,
            asset?.DecimalPoint,
            truncateZeros
        );

        return `${assetWithDecimal}`;
    }

    return numeral(amount)
        .format('0,.00');
};

export default formatAsAsset;